import * as S from './SkeletonRow.styles'

function SkeletonRow({ width, height, ...otherProps }) {
  return (
    <S.SkeletonRow
      style={{ width: `${width}px`, height: `${height}px` }}
      {...otherProps}
    />
  )
}

export default SkeletonRow
